<template>
    <svg
        version="1.1"
        id="图层_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1280 720"
        style="enable-background:new 0 0 1280 720;"
        xml:space="preserve"
    >
        <circle class="st0" cx="437.4" cy="360.5" r="107.4" />
        <g>
            <g>
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="785.6" cy="522.5" r="120.7" />
                    </defs>
                    <clipPath id="SVGID_00000142880698686978151010000002383354629714331794_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000183244237079077272680000012433569039606155671_"
                        style="clip-path:url(#SVGID_00000142880698686978151010000002383354629714331794_);"
                    >
                        <g>
                            <circle class="st2" cx="762.2" cy="579.9" r="14" />
                            <circle class="st2" cx="765.2" cy="539.4" r="14" />
                            <circle class="st2" cx="777.8" cy="502.4" r="14" />
                            <circle class="st2" cx="798.9" cy="470.8" r="14" />
                            <circle class="st2" cx="827.4" cy="446.6" r="14" />
                            <circle class="st2" cx="861.3" cy="432.1" r="14" />
                            <circle class="st2" cx="897.8" cy="427.8" r="14" />
                            <circle class="st2" cx="934.9" cy="433.5" r="14" />
                            <circle class="st2" cx="970.3" cy="448.6" r="14" />
                            <circle class="st2" cx="1002" cy="473" r="14" />

                            <ellipse
                                transform="matrix(0.3827 -0.9239 0.9239 0.3827 166.8653 1261.9316)"
                                class="st2"
                                cx="1027.7"
                                cy="506.1"
                                rx="14"
                                ry="14"
                            />
                        </g>
                        <circle class="st2" cx="770.7" cy="638.9" r="28.1" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.8" cy="483.8" r="20.9" />
            <circle class="st3" cx="785.6" cy="522.5" r="120.7" />
            <polyline class="st4" points="875.5,510.3 897.2,538.5 951,483.8 	" />
        </g>
        <g>
            <g>
                <g>
                    <defs>
                        <circle id="SVGID_00000033369951689911397510000007795032026328788875_" cx="785.6" cy="198.5" r="120.7" />
                    </defs>
                    <clipPath id="SVGID_00000181047955654480907650000012951851439733309103_">
                        <use xlink:href="#SVGID_00000033369951689911397510000007795032026328788875_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000084490555774066418310000013876581186648035490_"
                        style="clip-path:url(#SVGID_00000181047955654480907650000012951851439733309103_);"
                    >
                        <g>
                            <circle class="st2" cx="834.2" cy="225.9" r="14" />
                            <circle class="st2" cx="865.4" cy="252" r="14" />
                            <circle class="st2" cx="888.1" cy="283.9" r="14" />
                            <circle class="st2" cx="901.5" cy="319.4" r="14" />
                            <circle class="st2" cx="904.5" cy="356.6" r="14" />
                            <circle class="st2" cx="896.5" cy="392.6" r="14" />
                            <circle class="st2" cx="878.6" cy="424.8" r="14" />
                            <circle class="st2" cx="852.4" cy="451.6" r="14" />
                            <circle class="st2" cx="819.4" cy="471.5" r="14" />
                            <circle class="st2" cx="781.2" cy="483.1" r="14" />
                            <circle class="st2" cx="739.2" cy="484.6" r="14" />
                        </g>
                        <circle class="st2" cx="781.4" cy="198.4" r="28.1" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.8" cy="159.8" r="20.9" />
            <circle class="st3" cx="785.6" cy="198.5" r="120.7" />
            <polyline class="st4" points="875.5,167 897.2,195.3 951,140.6 	" />
        </g>
    </svg>
</template>
     
<style scoped>
.st0 {
    fill: #0ee515;
}
.st1 {
    clip-path: url(#SVGID_00000063631783964227010730000015106823497281639861_);
}
.st2 {
    fill: var(--color_back);
}
.st3 {
    fill: none;
    stroke: #8b8b8b;
    stroke-width: 9.6132;
    stroke-miterlimit: 10;
}
.st4 {
    fill: none;
    stroke: #0ee515;
    stroke-width: 27.7716;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
.st5 {
    clip-path: url(#SVGID_00000042718032091895121320000011522057016050304155_);
}
</style>
